import React from 'react';
import { formatDateOrDash } from "../../../components/Utils/Dates";
import Card from '../../../components/Cards/Card';
import BootstrapTable from 'react-bootstrap-table-next';
import Loader from '../../../components/Common/Loader';
import { Col, Row } from "react-bootstrap";
import { PaginationRequest } from '../../../api/Common/Util';
import useProtocolItems from '../Hooks/useProtocolItems';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Tooltip } from '../../../components/Utils/Tooltips';
import { useHistory } from "react-router-dom";
import { Edit, More } from '../../../components/Icons/Icons';
import { CustomSearchBox } from '../../../components/CustomControls/CustomSearchBox';
import { WithAuth } from '../../../components/Authorization/WithAuth';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export default function ProtocolItemsPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const [pagedItems, isLoading, navigation] = useProtocolItems({
        preload: true,
        requestProps: {
            ...new PaginationRequest({
                pageSize: 10,
                pageNumber: 1,
                sortOrder: 'asc',
            }),
            includeStock: true, includeLastEntry: true,
        }
    });

    const handleShowDetail = (itemId) => {
        history.push('/admin/inventory/items/protocol/' + itemId);
    };

    const handleEditItem = (itemId) => {
        history.push('/admin/inventory/items/protocol/' + itemId + '/edit');
    };

    const columns = [
        {
            text: t('commons.date'), headerStyle: { width: '6rem' },
            formatter: function (_cell, item, rowIndex) {
                return moment(item.createAt).format("DD/MM/YYYY");
            }
        },
        { dataField: 'presentation', text: t('inventory.commons.presentation'), headerStyle: { width: '15.625rem' } },
        { dataField: 'stockQuantity', text: t('inventory.commons.stock'), headerStyle: { width: '3rem' } },
        {
            text: t('inventory.movements.commons.lastEntry'), headerStyle: { width: '6rem' },
            formatter: function (_cell, item, rowIndex) {
                return formatDateOrDash(item.lastEntry, "DD/MM/YYYY HH:mm");
            }
        },
        {
            dataField: 'view',
            text: "",
            isDummyField: true,
            headerClasses: 'header-actions',
            classes: 'row-actions',
            formatter: function (_cell, row, rowIndex) {
                return (
                    <div key={rowIndex}>
                        <WithAuth requiredPermission={["ProtocolInventory.Edit"]}>
                            {`${row.type}`.toLowerCase() === 'protocol' && (
                                <button className="btn-table-actions" onClick={() => { handleEditItem(row.id); }}>
                                    <Tooltip tooltip={t('buttons.edit')} id={"tooltip-edit-" + row.id}>
                                        <span aria-hidden="true"><Edit /></span>
                                    </Tooltip>
                                </button>
                            )}
                        </WithAuth>
                        <WithAuth requiredPermission={["ProtocolInventory.View"]}>
                            <button className="btn-table-actions" onClick={() => { handleShowDetail(row.id); }}>
                                <Tooltip tooltip={t('commons.viewDetails')} id={"tooltipedit-" + row.Id}>
                                    <span aria-hidden="true"><More /></span>
                                </Tooltip>
                            </button>
                        </WithAuth>
                    </div>
                );
            }
        }
    ];

    const handleSearch = async (q) => {
        await navigation.Find({ search: q });
    };

    const handleCreateProtocolItem = () => {
        history.push('/admin/inventory/items/protocol/create');
    };

    const onTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        navigation.ToPage({ page });
    };

    return (
        <Card
            header={<Row>
                <Col sm={12} md={4}>
                    <CustomSearchBox handleSearch={handleSearch} placeholder={t('inventory.commons.searchMedication')} />
                </Col>
                <Col sm={12} md={4} mdOffset={4} className='text-right'>
                    <WithAuth requiredPermission={["ProtocolInventory.Edit"]}>
                        <button className='btn btn-sm btn-success'
                            onClick={handleCreateProtocolItem}>{t("inventory.commons.newProtocolItem")}</button>
                    </WithAuth>
                </Col>
            </Row>}
            content={
                <Loader isLoading={isLoading}>
                    <BootstrapTable
                        bordered={false}
                        hover
                        remote
                        condensed
                        keyField='id'
                        classes="table-spaced table-spaced-small"
                        wrapperClasses="table-responsive"

                        pagination={paginationFactory({
                            page: pagedItems.PageNumber,
                            sizePerPage: pagedItems.PageSize,
                            totalSize: pagedItems.TotalCount,
                            hideSizePerPage: true
                        })}
                        onTableChange={onTableChange}

                        data={pagedItems.Values}
                        columns={columns}
                        loading={isLoading}
                        noDataIndication={() => <>{t("commons.noData")}</>}
                    />
                </Loader>
            }
        />
    );
}
